<template>
  <v-card color="blue">
    <div
      @dragenter.prevent="toggleActive"
      @dragleave.prevent="toggleActive"
      @dragover.prevent
      @drop.prevent="toggleActive"
      @drop="addFileDroped($event, num)"
      :class="{ 'active-dropzone': active }"
      ref="fileDiv"
      class="dropzone"
    >
      <span>Arrastre el archivo aquí</span>
      <span>O</span>
      <label for="dropzoneFile" class="labelButton"
        >Seleccione un archivo para subir</label
      >
      <input
        @change="addFile(num)"
        ref="file"
        type="file"
        name
        id="dropzoneFile"
        accept=".pdf,.jpg,.png,.docx,.xlsx,.ppt,.pptx"
      />
    </div>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      num: Number,
      active: false,
    };
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
    },
    addFile(number) {
      this.$emit("addFile", {
        number: number,
        file: this.$refs.file.files[0],
      });
    },
    addFileDroped(e, number) {
      this.$emit("addFileDroped", {
        number: number,
        file: e.dataTransfer.files[0],
      });
    },
  },
};
</script>
<style scoped>
.dropzone {
  width: 100%;
  height: 60%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: 0.4s ease all;
  background-color: #d0c8c8;
}

.active-dropzone {
  color: #fff;
  border-color: #fff;
  background-color: #41b883;
}

.labelButton {
  padding: 1% 1%;
  align-content: center;
  color: #fff;
  background-color: #015caba1;
  transition: 0.3s ease all;
}

#dropzoneFile {
  display: none;
}
</style>